import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedResponse } from '../common/types';
import type {
    ReviewerAssignmentItem,
    GetReviewerAssignmentPayload,
    ReviewedManuscriptForReReviewItem,
    ReviewerItem,
    ReviewerCategory,
    GetReviewersPayload,
    CreateUpdateReviewerCategoryPayload,
    ReviewerStats,
    GetReviewerStatsPayload,
    SubmitGradingPayload,
} from './types';

export const reviewCategoryService = {
    getAllReviewers: async (payload: GetReviewersPayload): Promise<ApiResponse<PaginatedResponse<ReviewerItem>>> => {
        const response = await apiClient.post('/ReviewCategory/GetReviewerCategory', payload);
        return response.data;
    },

    createUpdateReviewerCategory: async (payload: CreateUpdateReviewerCategoryPayload): Promise<ApiResponse<ReviewerCategory>> => {
        const response = await apiClient.post('/ReviewCategory/CreateUpdateReviewCategory', payload);
        return response.data;
    },

    deleteReviewerCategory: async (id: string): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(`/ReviewCategory/${id}`);
        return response.data;
    },

    getReviewerStats: async (payload: GetReviewerStatsPayload): Promise<ApiResponse<PaginatedResponse<ReviewerStats>>> => {
        const requestPayload = {
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            sortBy: payload.sortBy || '',
            sortDescending: payload.sortDescending ?? true,
            search: payload.search || '',
            categoryId: payload.categoryId || 0,
            applicationType: payload.applicationType || 0,
            cycleId: payload.cycleId || 0
        };
        const response = await apiClient.post('/ReviewAssignments/GetReviewerStats', requestPayload);
        return response.data;
    }
};

export const accessorService = {
    getReviewerAssignment: async (payload: GetReviewerAssignmentPayload): Promise<ApiResponse<PaginatedResponse<ReviewerAssignmentItem>>> => {
        const response = await apiClient.post('/ReviewAssignments/GetReviewerAssignment', payload);
        return response.data;
    },

    getReviewedManuscriptForReReview: async (payload: GetReviewerAssignmentPayload): Promise<ApiResponse<PaginatedResponse<ReviewedManuscriptForReReviewItem>>> => {
        const response = await apiClient.post('/ReviewAssignments/GetReviewedManuscriptForReReview', payload);
        return response.data;
    },

    getSubmissionCaseFile: async (submissionId: string): Promise<ApiResponse<any>> => {
        const response = await apiClient.get(`/Submissions/GetSubmissionCaseFile?submissionId=${submissionId}`);
        return response.data;
    },

    getSubmissionCaseFileByReviewer: async (submissionId: string): Promise<ApiResponse<any>> => {
        const response = await apiClient.get(`/Submissions/GetSubmissionCaseFileByReviewer?SubmissionId=${submissionId}`);
        return response.data;
    },

    submitGrading: async (payload: SubmitGradingPayload): Promise<ApiResponse<void>> => {
        const response = await apiClient.post('/Reviews/SubmitGrading', payload);
        return response.data;
    }
};
